import { Box } from 'native-base';
import React, { useCallback } from 'react';
import { ScheduleList } from '../../components/schedule/ScheduleList';
import { Activity } from '../../models/view';
import { ScheduleStackScreenWithNavProps } from '../../navigation/AppNavigation';
import { isWeb } from '../../utils';

export const ScheduleScreen: React.FC<ScheduleStackScreenWithNavProps<'Schedule'>> = ({ navigation, route }) => {
  const handleItemPress = useCallback(
    (item: Activity) => {
      if (item.source === 'graduwayEvent') {
        navigation.navigate('GraduwayEvent', { id: item.id });
      } else {
        navigation.navigate('Event', { id: item.id });
      }
    },
    [navigation],
  );

  return (
    <Box flex={1} alignItems={isWeb ? 'center' : undefined}>
      <ScheduleList onItemPress={handleItemPress} />
    </Box>
  );
};
